var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPinStop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 30,
    viewBox: "0 0 17 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.54883 29.477H9.26621V14.0205H7.54883V29.477Z",
    fill: "#2B303A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.97806 29.0483H8.83652V14.4507H7.97806V29.0483ZM9.26576 29.9072H7.54837C7.3116 29.9072 7.11914 29.7147 7.11914 29.4775V14.0215C7.11914 13.7843 7.3116 13.5918 7.54837 13.5918H9.26576C9.50299 13.5918 9.69545 13.7843 9.69545 14.0215V29.4775C9.69545 29.7147 9.50299 29.9072 9.26576 29.9072Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.40769 1.14062C12.676 1.14062 16.1357 4.60078 16.1357 8.86862C16.1357 13.1369 12.676 16.5966 8.40769 16.5966C4.13938 16.5966 0.679688 13.1369 0.679688 8.86862C0.679688 4.60078 4.13938 1.14062 8.40769 1.14062Z",
    fill: "#F9603A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.40723 1.57038C4.38262 1.57038 1.10846 4.84453 1.10846 8.86914C1.10846 12.8938 4.38262 16.1675 8.40723 16.1675C12.4314 16.1675 15.7055 12.8938 15.7055 8.86914C15.7055 4.84453 12.4314 1.57038 8.40723 1.57038ZM8.40723 17.0268C3.90908 17.0268 0.25 13.3673 0.25 8.86914C0.25 4.37099 3.90908 0.711914 8.40723 0.711914C12.9054 0.711914 16.5645 4.37099 16.5645 8.86914C16.5645 13.3673 12.9054 17.0268 8.40723 17.0268Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.40144 5.43457C6.11267 5.43457 6.68959 6.01149 6.68959 6.72272C6.68959 7.43396 6.11267 8.01088 5.40144 8.01088C4.68974 8.01088 4.11328 7.43396 4.11328 6.72272C4.11328 6.01149 4.68974 5.43457 5.40144 5.43457Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinStop);
export default __webpack_public_path__ + "static/media/pin-stop.22ef128ffbec393072500c84781e8439.svg";
export { ForwardRef as ReactComponent };